<template>
    <div class="body">
        <!--导航栏-->
        <mslNav></mslNav>
        <!-- banner -->
        <div class="banner">
            <img src="../assets/images/company_head.png" alt="">
        </div>
        <!-- 企业背景 -->
        <div class="enterprise_bg">
            <div class="title ta_center" v-if="baseInfo.company_backdrop && baseInfo.company_backdrop.id">{{ baseInfo.company_backdrop.title }}</div>
            <div class="page_1 ta_center mt_8" v-if="baseInfo.company_backdrop && baseInfo.company_backdrop.id" v-html="baseInfo.company_backdrop.content"></div>
        </div>
        <!-- 曼稣勒文化 -->
        <div class="culture">
            <div class="enterprise column_center">
                <div class="title" v-if="baseInfo.company_banner && baseInfo.company_banner.id">{{ baseInfo.company_banner.title }}</div>
                <div class="intro" v-if="baseInfo.company_banner && baseInfo.company_banner.id" v-html="baseInfo.company_banner.content"></div>
            </div>
        </div>

        <!-- 卡片 -->
        <div class="card">
            <div class="c_item left_center">
                <div class="left flex-box-0">
                    <span class="iconfont iconzu303 icon"></span>
                </div>
                <div class="right flex-box-1">
                    <div class="title ta_left">公司愿景</div>
                    <div class="intro ta_left">成就智能健康行业高端优质品牌！</div>
                </div>
            </div>
            <div class="c_item left_center">
                <div class="left flex-box-0">
                    <span class="iconfont iconzu304 icon"></span>
                </div>
                <div class="right flex-box-1">
                    <div class="title ta_left">企业使命</div>
                    <div class="intro ta_left">让更多的人使用上智能健康的曼稣勒品牌产品！</div>
                </div>
            </div>
            <div class="c_item left_center">
                <div class="left flex-box-0">
                    <span class="iconfont iconzu305 icon"></span>
                </div>
                <div class="right flex-box-1">
                    <div class="title ta_left">企业精神</div>
                    <div class="intro ta_left">追求卓越品质 铸造百年品牌！</div>
                </div>
            </div>
            <div class="c_item left_center">
                <div class="left flex-box-0">
                    <span class="iconfont iconzu306 icon"></span>
                </div>
                <div class="right flex-box-1">
                    <div class="title ta_left">传递价值</div>
                    <div class="intro ta_left">赢在起点，一切以客户需求为核心价值！</div>
                </div>
            </div>
            <div class="c_item left_center">
                <div class="left flex-box-0">
                    <span class="iconfont iconzu307 icon"></span>
                </div>
                <div class="right flex-box-1">
                    <div class="title ta_left">员工管理</div>
                    <div class="intro ta_left">关心员工成长、强化执行能力、追求高效和谐、平衡激励约束！</div>
                </div>
            </div>
        </div>
        <!-- 留言咨询 -->
        <div class="msg_area">
            <mslMsg></mslMsg>
        </div>

        <!-- 底部 -->
        <mslFooter></mslFooter>
    </div>
</template>

<script>
    import { baseInfo } from '../api/common.js'
    export default {
        name: "company_info",
        data() {
            return {
                baseInfo: {},
            }
        },
        mounted() {
            this.getBaseInfo();
        },
        methods: {
            getBaseInfo () {
                try {
                    baseInfo().then(res => {
                        if(res.code == 1) {
                            this.baseInfo = res.data;
                            console.log(this.baseInfo, 'this.baseInfo');
                        }
                    })
                } catch {
                    // this.$message.error('获取数据失败，请刷新')
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .body {
        background-color: #fafafa;
        /* banner */
        .banner {
            width: 100%;
            height: 330px;
            img {
                width: 100%;
                height: 330px;
            }
        }

        /* 企业背景 */
        .enterprise_bg {
            padding: 24px;
            box-sizing: border-box;
            .title {
                font-size: 20px;
                font-family: PingFang SC;
                font-weight: bold;
                line-height: 24px;
                color: #262626;
            }
            .page_1 {
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 21px;
                color: #8C8C8C;
            }
            .mt_14 {
                margin-top: 14px;
            }
            .mt_8 {
                margin-top: 8px;
            }
        }

        /* 曼稣勒文化 */
        .culture {
            padding: 0 16px;
            box-sizing: border-box;
            .enterprise {
                padding: 30px;
                box-sizing: border-box;
                width: 100%;
                background-color: rgba(38, 38, 38, 1);
                border-radius: 4px;
                .title {
                    font-size: 16px;
                    font-weight: bold;
                    line-height: 24px;
                    color: #FFFFFF;
                }
                .intro {
                    margin-top: 6px;
                    font-size: 12px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    line-height: 18px;
                    color: #FFFFFF;
                    opacity: 0.8;
                    &::v-deep {
                        p {
                            margin-top: 0!important;
                            margin-bottom: 0!important;
                        }
                    }
                }
            }
        }

        /* 卡片 */
        .card {
            padding: 24px 16px;
            box-sizing: border-box;
            .c_item {
                width: 100%;
                height: 121px;
                background: #FFFFFF;
                box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.06);
                border-radius: 4px;
                padding: 0 27px;
                box-sizing: border-box;
                margin-top: 20px;
                &:first-child {
                    margin-top: 0px;
                }
                .left {
                    .icon {
                        font-size: 48px;
                        color: #262626;
                    }
                }
                .right {
                    margin-left: 20px;
                    .title {
                        font-size: 16px;
                        font-family: PingFang SC;
                        font-weight: bold;
                        line-height: 21px;
                        color: #262626;
                    }
                    .intro {
                        margin-top: 4px;
                        font-size: 14px;
                        font-family: PingFang SC;
                        font-weight: 500;
                        line-height: 21px;
                        color: #8C8C8C;
                        &::v-deep {
                            p {
                                margin-top: 0!important;
                                margin-bottom: 0!important;
                            }
                        }
                    }
                }
            }
        }

        /* 留言咨询 */
        .msg_area {
            padding: 0 16px;
            padding-bottom: 24px;
            box-sizing: border-box;
        }

    }


</style>
